<mat-card
    class="daxa-card recent-orders-card mb-25 border-radius bg-white border-none d-block p-3"
    [class.rtl-enabled]="themeService.isRTLEnabled()"
>
    <mat-card-header>
        <mat-card-title>
            <form class="search-box position-relative">
                <i class="material-symbols-outlined">
                    search
                </i>
                <input type="text" class="input-search d-block w-100 border-none outline-0 rounded-pill"
                       placeholder="Chercher une exploitation..."
                       (keyup)="applyFilter($event)" #input>
            </form>
        </mat-card-title>
        <mat-card-subtitle>
            <button class="btn btn-primary btn-sm rounded-start-pill" (click)="openModal(content)">
                <span class="px-2">Nouveau</span>
            </button>
            <button class="btn btn-outline-primary btn-sm rounded-end-pill" [matMenuTriggerFor]="menu"
                    aria-haspopup="true" aria-expanded="false" id="dropdownMenuClickableInside">
                <i class="fa-solid fa-table px-3"></i>
            </button>

        </mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
        <div class="recent-orders-table">
            <div class="table-responsive">
                <table mat-table [dataSource]="dataSource" matSort>

                    <!-- Name Column -->
                    <ng-container matColumnDef="name">
                        <th mat-header-cell  *matHeaderCellDef mat-sort-header> Nom</th>
                        <td mat-cell *matCellDef="let element"> {{ element.name }}</td>
                    </ng-container>


                    <ng-container matColumnDef="typeId">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Type</th>
                        <td mat-cell *matCellDef="let element"> {{ element.typeName }} </td>
                    </ng-container>

                    <!-- Client Column -->
                    <ng-container matColumnDef="client">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Client</th>
                        <td mat-cell *matCellDef="let element"> {{ element.clientIdentification }}</td>
                    </ng-container>

                    <!-- Address Column -->
                    <ng-container matColumnDef="details">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Détails</th>
                        <td mat-cell *matCellDef="let element"> {{ element.details }}</td>
                    </ng-container>

                    <!-- Flag Column -->
                    <ng-container matColumnDef="flag">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Statut</th>
                        <td mat-cell *matCellDef="let element"> {{ element.flag ? 'Actif' : 'Inactif' }}</td>
                    </ng-container>

                    <!-- Creation Date Column -->
                    <ng-container matColumnDef="creationDate">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Céé le</th>
                        <td mat-cell *matCellDef="let element"> {{ element.creationDate }}</td>
                    </ng-container>

                    <!-- Update Date Column -->
                    <ng-container matColumnDef="updateDate">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> modifié le</th>
                        <td mat-cell *matCellDef="let element"> {{ element.updateDate }}</td>
                    </ng-container>

                    <!-- Created By Column -->
                    <ng-container matColumnDef="createdBy">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Créé par</th>
                        <td mat-cell *matCellDef="let element"> {{ element.user_name }}</td>
                    </ng-container>

                    <!-- Action Column -->
                    <ng-container matColumnDef="action">
                        <th mat-header-cell *matHeaderCellDef> Actions</th>
                        <td mat-cell *matCellDef="let element">
                            <div class="action-info text-center" style="justify-content: center !important;">
                                <button type="button" mat-button matTooltip="Visualiser" matTooltipPosition="above"
                                        (click)="openViewModal(element, viewModal)">
                                    <i class="material-symbols-outlined">
                                        visibility
                                    </i>
                                </button>
                                <button type="button" mat-button matTooltip="Modifier" matTooltipPosition="above"
                                        (click)="openEditModal(element)">
                                    <i class="material-symbols-outlined text-primary">
                                        brush
                                    </i>
                                </button>
                                <button type="button" mat-button matTooltip="Supprimer" matTooltipPosition="above"
                                        (click)="confirmDelete(element)">
                                    <i class="material-symbols-outlined text-danger">
                                        delete
                                    </i>
                                </button>
                            </div>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="getdisplayedCol()"></tr>
                    <tr mat-row *matRowDef="let row; columns: getdisplayedCol();"></tr>

                    <div *ngIf="!loadingTable">
                    <tr class="mat-row" *matNoDataRow>
                        <td class="mat-cell" colspan="15">Aucun résultat trouvé pour "{{ input.value }}"</td>
                    </tr>
                    </div>
                </table>
                <div *ngIf="loadingTable">
                    <div *ngFor="let i of [].constructor(6)" class="skeleton-row">
                        <span class="skeleton-cell"></span>
                    </div>
                </div>
            </div>
            <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
        </div>
    </mat-card-content>


</mat-card>

<!-- Add modal template for nv -->
<ng-template #content let-modal>
    <mat-card class="daxa-card border-radius bg-white border-none d-block">
        <mat-card-header>
            <mat-card-title>
                <h5 class="my-0">
                    Nouvelle exploitation
                </h5>
            </mat-card-title>
        </mat-card-header>
        <mat-card-content>
            <form [formGroup]="form" (ngSubmit)="save()">
                <div class="row">
                    <div class="col-4">

                        <div class="col-sm-12">
                            <mat-form-field class="mb-25">
                                <mat-label>Nom</mat-label>
                                <input matInput formControlName="name" placeholder="Ex. Exploitation du nord" required>
                                <mat-error *ngIf="form.get('name')?.hasError('required')">Champ obligatoire</mat-error>
                            </mat-form-field>
                        </div>

                        <div class="col-sm-12">
                            <mat-form-field class="mb-25">
                                <mat-label>Type</mat-label>
                                <mat-select formControlName="typeId" required>
                                    <mat-option *ngFor="let type of exploitationTypes" [value]="type.id">
                                    {{ type.name }}
                                    </mat-option>
                                </mat-select>
                                <mat-error *ngIf="form.get('type')?.hasError('required')">Champ obligatoire</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-sm-12">
                               <mat-form-field class="mb-25">
                                <mat-label>Statut</mat-label>
                                <mat-select formControlName="flag" required>
                                    <mat-option [value]="true">Actif</mat-option>
                                    <mat-option [value]="false">Inactif</mat-option>
                                </mat-select>
                                </mat-form-field>
                        </div>

                        <div class="col-sm-12">
                            <mat-form-field class="mb-25">
                                <mat-label>Client</mat-label>
                                <mat-select formControlName="clientId" placeholder="Select a client" required>
                                    <mat-option *ngFor="let client of clientList" [value]="client.id">
                                        {{ client.socialReason }}
                                    </mat-option>
                                </mat-select>
                                <mat-error *ngIf="form.get('clientId')?.hasError('required')">Champ obligatoire</mat-error>
                            </mat-form-field>
                        </div>

                        <div class="col-sm-12">
                            <mat-form-field class="mb-25">
                                <mat-label>Détails</mat-label>
                                <textarea matInput formControlName="details" placeholder="Ex. 123 Main St"></textarea>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="col-8 row">
                        <div class="col-sm-12">
                            <mat-form-field class="mb-25">
                                <mat-label>Latitude</mat-label>
                                <input type="number" matInput formControlName="lat">
                                <mat-error *ngIf="form.get('lat')?.hasError('required')">Champ obligatoire</mat-error>
                            </mat-form-field>
                        </div>
                        
                        <div class="col-sm-12">
                            <mat-form-field class="mb-25">
                                <mat-label>Longitude</mat-label>
                                <input type="number" matInput formControlName="lon">
                                <mat-error *ngIf="form.get('lon')?.hasError('required')">Champ obligatoire</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-sm-12">
                            <div id="map-for-new-modal" style="height: 310px; width: auto"></div>
                        </div>
                    </div>
                </div>
                <div class="col-sm-12 text-right">
                    <button type="submit" class="btn btn-primary btn-sm me-3">Sauvegarder</button>
                    <button type="reset" class="btn btn-secondary btn-sm ">Ré-initialiser</button>
                </div>
            </form>
        </mat-card-content>
    </mat-card>
</ng-template>

<!--  modal template for editing -->
<ng-template #editModal let-modal>
    <mat-card class="daxa-card border-radius bg-white border-none d-block">
        <mat-card-header>
            <mat-card-title>
                <h5 class="mt-0 mb-0">
                    Modifier Exploitation
                </h5>
            </mat-card-title>
        </mat-card-header>
        <mat-card-content>
            <form [formGroup]="editForm" (ngSubmit)="update()">
                <div class="row">
                    <div class="col-4">      <!-- Form fields here -->
                        <div class="col-sm-12">
                            <mat-form-field class="mb-25">
                                <mat-label>Nom</mat-label>
                                <input matInput formControlName="name" placeholder="Ex. Exploitation du nord">
                                <mat-error *ngIf="editForm.get('name')?.hasError('required')">Name is required</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-sm-12">
                            <mat-form-field class="mb-25">
                                <mat-label>type</mat-label>
                                <mat-select formControlName="typeId" required>
                                    <mat-option *ngFor="let type of exploitationTypes" [value]="type.id">
                                    {{ type.name }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>

                        <div class="col-sm-12">
                            <mat-form-field class="mb-25">
                                <mat-label>Statut</mat-label>
                                <mat-select formControlName="flag">
                                    <mat-option [value]="true">Actif</mat-option>
                                    <mat-option [value]="false">Inactif</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div class="col-sm-12">
                            <mat-form-field class="mb-25">
                                <mat-label>Details</mat-label>
                                <textarea matInput formControlName="details" placeholder="Ex. 123 Main St"></textarea>
                            </mat-form-field>
                        </div>

                        <div class="col-sm-12">
                            <mat-form-field>
                                <mat-label>Client</mat-label>
                                <mat-select formControlName="clientId" placeholder="Select a client">
                                    <mat-option *ngFor="let client of clientList" [value]="client.id">
                                        {{ client.socialReason }}
                                    </mat-option>
                                </mat-select>
                                <mat-error *ngIf="editForm.get('clientId')?.hasError('required')">Client is required
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="col-8 row">
                        <div class="col-sm-6">
                            <mat-form-field >
                                <mat-label>Longitude</mat-label>
                                <input type="number" matInput
                                       [(ngModel)]="coordonnes.longitude" [value]="coordonnes.longitude"
                                       (ngModelChange)="updateCoordonnees()"
                                       [ngModelOptions]="{standalone: true}"
                                >
                            </mat-form-field>
                        </div>

                        <div class="col-sm-6">
                            <mat-form-field >
                                <mat-label>Latitude</mat-label>
                                <input type="number" matInput
                                       [(ngModel)]="coordonnes.latitude" [value]="coordonnes.latitude"
                                       (ngModelChange)="updateCoordonnees()"
                                       [ngModelOptions]="{standalone: true}"
                                >
                            </mat-form-field>
                        </div>
                        <div class="col-12">

                            <div id="edit-modal-map" style="height: 340px; width: auto"></div>
                        </div>
                    </div>

                    <div class="col-sm-12 text-right">
                        <button type="submit" class="btn btn-outline-success">Enregister</button>
                    </div>
                </div>
            </form>
        </mat-card-content>
    </mat-card>
</ng-template>


<ng-template #viewModal let-modal>
    <mat-card class="daxa-card border-radius bg-white border-none d-block">
        <mat-card-content>
            <h5 class="px-3 fw-bolder">Détails de l'Exploitation :</h5>
            <div class="row">
                <div class="col-4">
                    <!-- Name Field -->
                    <div class="col-12 border-top p-3">
                        <div class="fw-bold">Nom :</div>
                        <p>{{ exploitation?.name }}</p>
                    </div>
                    <!-- Professional Field -->
                    <div class="col-12 border-top p-3">
                        <div class="fw-bold">Type :</div>
                        <p>{{ exploitation?.typeName }}</p>
                    </div>

                    <!-- Flag Field -->
                    <div class="col-12 border-top p-3">
                        <div class="fw-bold">Statut :</div>
                        <p>{{ exploitation?.flag ? 'Actif' : 'Inactif' }}</p>
                    </div>

                    <!-- Creation Date Field -->
                    <div class="col-12 border-top p-3">
                        <div class="fw-bold">Céé le :</div>
                        <p>{{ exploitation?.creationDate | date : 'short' }}</p>
                    </div>

                    <!-- Update Date Field -->
                    <div class="col-12 border-top p-3">
                        <div class="fw-bold">Modifié le :</div>
                        <p>{{ exploitation?.updateDate | date : 'short' }}</p>
                    </div>

                    <!-- Client Identification Field -->
                    <div class="col-12 border-top p-3">
                        <div class="fw-bold">Client :</div>
                        <p>{{ exploitation?.clientIdentification }}</p>
                    </div>

                    <!-- User Name Field -->
                    <div class="col-12 border-top p-3">
                        <div class="fw-bold">Céé par :</div>
                        <p>{{ exploitation?.user_name }}</p>
                    </div>

                    <!-- Details Field -->
                    <div class="col-12 border-top p-3">
                        <div class="fw-bold">Détails :</div>
                        <p>{{ exploitation?.details }}</p>
                    </div>
                </div>
                <div class="col-8 row">
                    <!-- Latitude Field -->
                    <div class="col-lg-6 border-top p-3">
                        <div class="fw-bold">Latitude :</div>
                        <p>{{ exploitation?.lat }}</p>
                    </div>

                    <!-- Longitude Field -->
                    <div class="col-lg-6 border-top p-3">
                        <div class="fw-bold">Longitude :</div>
                        <p>{{ exploitation?.lon }}</p>
                    </div>
                    <div class="col-sm-12"  style="height: 470px;" id="map-view-modal"></div>
                </div>

            </div>
        </mat-card-content>
    </mat-card>
</ng-template>

<!-- Menu with Checkboxes -->
<mat-menu #menu="matMenu">
    <div class="scrollable-menu shadow-lg bg-body">
        <mat-checkbox [checked]="displayedColumns.length == columns.length" (change)=" handleIsAllColsSelected($event)"
                      (click)="$event.stopPropagation()">Tous
        </mat-checkbox>
        @for (col of columns; track $index) {
            <div>
                <mat-checkbox [value]="col"
                              [checked]="displayedColumns.includes(col) || displayedColumns.length == columns.length"
                              (click)="$event.stopPropagation(); onSelectionChange(col)">
                    {{ columnLabels[col] || col }}
                </mat-checkbox>
            </div>
        }
    </div>

</mat-menu>

